var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ai-document" }, [
    _c("header", { staticClass: "ai-document__header" }, [
      _c("span", {
        staticClass: "ai-document__title",
        domProps: {
          textContent: _vm._s(
            !_vm.isEmpty() ? "Attachment Summary:" : "Attachment"
          ),
        },
      }),
      _vm._v(" "),
      _c("a", {
        staticClass: "ai-document__filename",
        style: { opacity: _vm.downloading ? 0.5 : 1 },
        attrs: { href: "#" },
        domProps: { innerHTML: _vm._s(_vm.resource.filename) },
        on: {
          click: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.handleDownload.apply(null, arguments)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "dl",
      { class: { "ai-document__list": true, "is-empty": _vm.isEmpty() } },
      [
        _vm.resource.overview_summary
          ? _c("div", [
              _c("dt", [_vm._v("Summary")]),
              _vm._v(" "),
              _c("dd", {
                domProps: { innerHTML: _vm._s(_vm.resource.overview_summary) },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.overview_key_people
          ? _c("div", [
              _c("dt", [_vm._v("Key People")]),
              _vm._v(" "),
              _c(
                "dd",
                _vm._l(_vm.resource.overview_key_people, function (people) {
                  return _c("p", { domProps: { innerHTML: _vm._s(people) } })
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.overview_primary_tag
          ? _c("div", { staticClass: "half" }, [
              _c("dt", [_vm._v("Primary Tag")]),
              _vm._v(" "),
              _c("dd", {
                domProps: {
                  innerHTML: _vm._s(_vm.resource.overview_primary_tag),
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.overview_primary_entity
          ? _c("div", { staticClass: "half" }, [
              _c("dt", [_vm._v("Primary Entity")]),
              _vm._v(" "),
              _c("dd", {
                domProps: {
                  innerHTML: _vm._s(_vm.resource.overview_primary_entity),
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.overview_secondary_corporate_entities
          ? _c("div", [
              _c("dt", [_vm._v("Secondary Entities")]),
              _vm._v(" "),
              _c(
                "dd",
                _vm._l(
                  _vm.resource.overview_secondary_corporate_entities,
                  function (entity) {
                    return _c("p", { domProps: { innerHTML: _vm._s(entity) } })
                  }
                ),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.overview_secondary_tags
          ? _c("div", [
              _c("dt", [_vm._v("Secondary Tags")]),
              _vm._v(" "),
              _c("dd", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.resource.overview_secondary_tags.join(", ")
                  ),
                },
              }),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }